import useHandlebarsContext from './useHandlebarsContext'
import insertHandlebarsTemplate from '../utils/insertHandlebarsTemplate'

/**
 * useTidyLink is a hook which returns a function to parse the `href`s and 'to`s by
 * inserting the dynamic params using handlebars.
 * @returns A function which takes a string argument (a link text to parse) and returns
 * the parsed string
 */
export default function useTidyLink(): (link?: string) => string {
  const handlebarsContext = useHandlebarsContext()

  return (link) => {
    if (!link) return ''

    try {
      const decodedLink = decodeURIComponent(link)
      const parsedLink =
        insertHandlebarsTemplate(decodedLink, handlebarsContext) ??
        decodedLink ??
        ''
      const [linkWithoutParams, queryStr] = parsedLink.split('?')
      const [queryStrWithoutHash, hash] = (queryStr ?? '').split('#')
      const urlSearchParams = new URLSearchParams(queryStrWithoutHash)
      const paramEntries = urlSearchParams.entries()

      // Remove all empty params like '?dt='
      for (const [key, value] of paramEntries) {
        if (!value) {
          urlSearchParams.delete(key)
        }
      }

      const tidyQueryStr = urlSearchParams.toString()
      const tidyLink = tidyQueryStr.length
        ? linkWithoutParams.concat(`?${tidyQueryStr}`)
        : linkWithoutParams

      if (hash) {
        return tidyLink.concat(`#${hash}`)
      }

      return tidyLink
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`useTidyLink was unable to parse the URL: "${link}"`)

      return link
    }
  }
}
